import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Chip from "@material-ui/core/Chip";
import Divider from "@material-ui/core/Divider";

import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import StudentRoleIcon from "../../../../../Assets/Logo/StudentRoleIcon.svg";
import TeacherRoleIcon from "../../../../../Assets/Logo/TeacherRoleIcon.svg";
import ParentRoleIcon from "../../../../../Assets/Logo/ParentRoleIcon.svg";
import { useStyles } from "./MobileDrawer.css";
import UserMenuDrawer from "../UserMenuDrawer/UserMenuDrawer";
import CustomDialogBox from "../../../../CustomDialogBox/CustomDialogBox";

class MobileDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
    };
  }

  handleDialogOpen = () => {
    this.setState({
      dialogOpen: true,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleLogout = () => {
    this.props.userLogout();
    this.handleDialogClose();
  };

  render() {
    const { classes } = this.props;
    let roleIcon =
      this.props.role === "Student"
        ? StudentRoleIcon
        : this.props.role === "Teacher"
        ? TeacherRoleIcon
        : this.props.role === "Parent" && ParentRoleIcon;
    return (
      <SwipeableDrawer
        anchor="left"
        open={this.props.mobileOpen}
        onOpen={this.props.handleToggleDrawer}
        onClose={this.props.handleToggleDrawer}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <div
          style={{
            display: "flex",
            padding: 10,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#eee",
          }}
        >
          <div style={{ fontSize: 18, fontWeight: "bold" }}>
            {this.props.userName}
          </div>
          <div style={{ paddingBottom: 10 }}>
            Role:
            <Chip
              icon={
                <img
                  src={roleIcon}
                  alt={this.props.role}
                  style={{ width: 20, height: 20 }}
                />
              }
              label={this.props.role}
            />
          </div>
          <Chip
            icon={<ExitToAppIcon style={{ color: "#fff" }} />}
            label="Logout"
            style={{ backgroundColor: "red", color: "#fff" }}
            onClick={this.handleDialogOpen}
          />

          <CustomDialogBox
            question="Are you sure you want to logout?"
            description="Click logout button to logout from the system"
            buttonLabel="Logout"
            open={this.state.dialogOpen}
            handleClose={this.handleDialogClose}
            handleDelete={this.handleLogout}
          />
        </div>
        <Divider />
        <UserMenuDrawer role={this.props.role} />
      </SwipeableDrawer>
    );
  }
}

export default withStyles(useStyles)(MobileDrawer);
